/*
 * @Author: Teemo Ding
 * @Date: 2021-04-15 16:28:43
 * @LastEditTime: 2021-04-26 11:28:17
 * @LastEditors: Teemo Ding
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/components/CheckImgDraggableDisplay/index.tsx
 */

import React from 'react';

//import css from './SalesChannelEditorPromotion.less';

import CheckImage from '@/src/constrains/CheckImage';
import { EnumLinkType } from '@/src/types/common/linkType';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import DragNDropColumns from 'src/components/DragNDropColumns';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  droppableId: string;
  data: any;
  onChange: (index, value) => void;
  onSort: (oldIndex, newIndex) => void;
  onDelete?: (index, e) => void;
  hideAdd?: boolean;
  onAdd: (e) => void;
  addText: string;
  specificError: any;
  disabled?: boolean;
  //To Do Delete Link Temp
}
const CheckImgDraggableDisplay = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,
    data,
    onChange,
    onSort,
    onDelete,
    hideAdd,
    onAdd,
    addText,
    specificError,
    disabled,
    //To Do Delete Link Temp
  } = props;

  const _onDelete = (index, E) => {
    if (onDelete) {
      onDelete(index, E);
    }
  };

  const childGenerate = (data, index) => {
    const { draggableId, linkModule, coverImage, visible } = data || {};
    const { linkImage } = linkModule || {};
    // console.log({ uuid, linkType, label, action });
    const imageErrorArray = specificError[`${draggableId}_imageError`] || [];
    return (
      <CheckImage
        imageErrorArray={imageErrorArray}
        checked={coverImage}
        {...(onDelete
          ? {
              onDelete: (e) => {
                _onDelete(index, e);
              },
            }
          : {})}
        linkImage={linkImage}
        title={
          <div
            style={{
              display: 'flex',
            }}>
            <div
              style={{ marginRight: 8, cursor: 'pointer' }}
              onClick={() => {
                if (onChange) {
                  onChange(index, {
                    linkModule: {
                      linkImage,
                      linkType: EnumLinkType.None,
                      draggableId,
                    },
                    coverImage,
                    visible: !!!visible,
                  });
                }
              }}>
              {visible ? (
                <EyeFilled style={{ color: '#61d77c' }} />
              ) : (
                <EyeInvisibleFilled />
              )}
            </div>
            {getI18n('general.checkImgDraggableDisplay.title')}
            {index + 1}
          </div>
        }
        subtitle={getI18n('general.tiprecommendedsize')}
        onCheckboxChange={(coverImage) => {
          if (onChange) {
            onChange(index, {
              linkModule: {
                linkImage,
                linkType: EnumLinkType.None,
                draggableId,
              },
              coverImage,
            });
          }
        }}
        imgOnChange={(linkImage) => {
          if (onChange) {
            onChange(index, {
              linkModule: {
                linkImage,
                linkType: EnumLinkType.None,
                draggableId,
              },
              coverImage,
            });
          }
        }}
        disabled={disabled}
      />
    );
  };

  const _onSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    if (onSort) onSort(oldIndex, newIndex);
  };

  return (
    <React.Fragment>
      <DragNDropColumns
        hideTitle
        childGenerate={childGenerate}
        data={data}
        droppableId={droppableId}
        onSort={_onSort}
        hideAdd={hideAdd}
        onAdd={onAdd}
        addText={addText}
        hideDrag={disabled}
      />
    </React.Fragment>
  );
};
export default CheckImgDraggableDisplay;
